// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1eH3E","gfeWrapper":"CalendarEvent_gfeWrapper__3YuMv"};